@let tableHeaderHeight = 102.5;
@let tableBodyHeight = 48 * ((currentTop | async) ?? 0);
<lib-table-options-row
  #tableOptionsRow
  class="table-options-spacing"
  [tableFilterGroups]="tableFilterGroups()"
  [tableColumns]="columns()"
  (tableFiltersUpdated)="onTableFiltersUpdated()"
  [searchesBadgeCount]="(currentSearchFilterExpressions | async)?.length ?? 0"
  [filtersBadgeCount]="(currentFilterGroups | async)?.length ?? 0"
  [hasData]="!!data()?.length || !exportCSVDataFn()"
  [exportCSVDataFn]="exportCSVDataFn()"
  (clearSearchesClick)="clearColumnFilters()"
  (viewingRowCount)="currentTopUpdated($event)">
</lib-table-options-row>
<div class="data-table-container table-options-spacing" [style.min-height]="tableHeaderHeight + tableBodyHeight + 'px'">
  <table class="data-table">
    <tr
      lib-table-header-row
      [columns]="columns()"
      [defaultSortColumn]="defaultSortColumn()"
      [defaultSortAsc]="defaultSortAsc()"
      (filterExpressions)="searchFilterExpressionsUpdated($event)"
      (sortExpression)="sortExpressionUpdated($event)"></tr>
    @if (loading() && (!data() || data()?.length === 0)) {
      <!-- If there is no data loaded yet, show loading indicators for all possible rows -->
      <tr *libRepeat="(currentTop | async) ?? 0" class="data-table-row hide-bottom-border-last-row">
        @for (column of columns(); track column) {
          <td>
            <lib-loading-shimmer class="data-table-cell"></lib-loading-shimmer>
          </td>
        }
      </tr>
    } @else if (!loading() && (!data() || data()?.length === 0)) {
      <tr [style.height]="tableBodyHeight + 'px'">
        <td [colSpan]="columns().length">
          <lib-table-no-results (adjustFiltersClicked)="tableOptionsRow.filtersClicked()"></lib-table-no-results>
        </td>
      </tr>
    } @else {
      @for (rowData of data(); track $index; let index = $index) {
        <tr class="data-table-row" [class.hide-bottom-border]="index === ((currentTop | async) ?? 0) - 1">
          @for (column of columns(); track $index) {
            <td (click)="tableCellClicked(column, rowData, $event)">
              @if (!!column.cellComponent) {
                <ng-container
                  *ngComponentOutlet="
                    column.cellComponent;
                    inputs: column.cellComponentInputsFunction | cellComponentRowDataPipe: rowData : loading()
                  ">
                </ng-container>
              } @else {
                <lib-loading-shimmer class="data-table-cell" [showLoading]="loading()">
                  @if (column.cellStyle) {
                    <div class="data-table-truncate"
                         libOverflow
                         #overflow="libOverflow"
                         [libTooltip]="overflow.isTruncated() ? column.value?.(rowData) ?? undefined : undefined"
                         style="{{column.cellStyle}}">
                      {{ column | tableColumnValue: rowData }}
                    </div>
                  } @else {
                    <div class="data-table-truncate"
                         libOverflow
                         #overflow="libOverflow"
                         [libTooltip]="overflow.isTruncated() ? column.value?.(rowData) ?? undefined : undefined">
                      {{ column | tableColumnValue: rowData }}
                    </div>
                  }
                </lib-loading-shimmer>
              }
            </td>
          }
        </tr>
      }
    }
  </table>
</div>
<lib-table-pagination
  [totalCount]="totalRowCount()"
  [top]="currentTop | async"
  [noResults]="!loading() && (!data() || data()?.length === 0)"
  [loading]="loading()"
  (skip)="currentSkipUpdated($event)">
</lib-table-pagination>
